import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const NavigatingUncertainty = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.navigatingUncertaintyBody}
      />
    </ArticleBody>
  </div>
);

NavigatingUncertainty.propTypes = {};

export default NavigatingUncertainty;
